import React, {useState} from 'react'
import {useOpenTemplatePicker, TemplateIdType} from './useOpenTemplatePicker'
import AccountPicker from '../account-picker/AccountPicker'

interface TemplateOpenerProps {
  templateId: TemplateIdType
  setTemplateId: React.Dispatch<React.SetStateAction<TemplateIdType>>
}

export type ITemplateOpenerContext = {
  setTemplateId: (templateId: string) => void
}

export const TemplateOpenerContext = React.createContext<ITemplateOpenerContext>({
  setTemplateId: () => {
    // do nothing
  },
})

export const TemplateOpenerProvider = (props: {children: React.ReactNode}): React.ReactElement => {
  const {children} = props
  const [templateId, setTemplateId] = useState<string | null>(null)

  return (
    <TemplateOpenerContext.Provider value={{setTemplateId}}>
      {children}
      <TemplateOpener templateId={templateId} setTemplateId={setTemplateId} />
    </TemplateOpenerContext.Provider>
  )
}

export const useTemplateOpener = (): ITemplateOpenerContext =>
  React.useContext(TemplateOpenerContext)

const TemplateOpener: React.FC<TemplateOpenerProps> = ({templateId, setTemplateId}) => {
  const [
    isAccountPickerVisible,
    onAccountPickerLoaded,
    onAccountPickerSubmit,
    onAccountPickerCancel,
    onAccountPickerError,
  ] = useOpenTemplatePicker(templateId, setTemplateId)

  return templateId ? (
    <AccountPicker
      isVisible={isAccountPickerVisible}
      onLoaded={onAccountPickerLoaded}
      onSubmit={onAccountPickerSubmit}
      onCancel={onAccountPickerCancel}
      onError={onAccountPickerError}
    />
  ) : null
}

export default TemplateOpener
